import packageJson from '../../package.json';

// 기본값
const basic = {
  'front.login.id': '아이디',
  'front.login.id.requireMessage': '아이디를 입력하십시오.',
  'front.login.password': '비밀번호',
  'front.login.password.requireMessage': '비밀번호를 입력하십시오.',
};

//
const frontKoKR = {
  default: basic,
  hanabank: {
    'front.login.id': '행번',
    'front.login.id.requireMessage': '행번을 입력하십시오.',
    'front.login.password': 'PC 로그인 비밀번호',
    'front.login.password.requireMessage': 'PC 로그인 비밀번호를 입력하십시오.',
  },
};

const koKR = packageJson.config?.preid
  ? { ...frontKoKR.default, ...frontKoKR[packageJson.config.preid] }
  : { ...frontKoKR.default };

export default koKR;
